import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchAuctionSearchBidBookData,
  fetchMarkDetailsByAuctionCenterId,
  fetchGradeDetailsByAuctionCenterId,
  fetchAuctionSearchBidBookDataApiCall,
  fetchSessionTimeForBidBook,
  fetchLotNumberBySessionDetailId,
  fetchLotNumberBySessionDetailIdSuccess,
  fetchAuctionSearchBidBookDataSuccess,
} from "../../store/actions";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";

let lotStatusData = [
  { lotKey: "All", lotValue: 4 },
  { lotKey: "Pending", lotValue: 0 },
  { lotKey: "Sold", lotValue: 1 },
  { lotKey: "Unsold", lotValue: 3 },
];

let generalType = 0;
function AuctionSearchBidBook({ fromLiveAuction }) {
  const dispatch = useDispatch();
  const [searchMarkId, setSearchMarkId] = useState("");
  const [searchGradeId, setSearchGradeId] = useState("");
  const [searchLotStatus, setSearchLotStatus] = useState(4);
  const [sessionTime, setSessionTime] = useState("");
  const [sessionDetailId, setSessionDetailId] = useState("");
  const [lotNumber, setLotNumber] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
    dispatch(fetchAuctionSearchBidBookDataSuccess([]));
    let tempData =
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[4];
    let auctionCenterId = tempData && atob(tempData);

    let payloadData = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
    };

    dispatch(fetchMarkDetailsByAuctionCenterId(payloadData));

    dispatch(fetchGradeDetailsByAuctionCenterId(payloadData));

    let sessionPaylod = {
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      auctionTypeMasterId: 1,
    };
    dispatch(fetchSessionTimeForBidBook(sessionPaylod));

    let payloadDataForDefault = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      gradeId: searchGradeId,
      markId: searchMarkId,
      bidderId:
        "BUYER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEBUYER" ==
          atob(localStorage.getItem("argument6")) ||
        "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEAUCTIONEER" ==
          atob(localStorage.getItem("argument6"))
          ? atob(localStorage.getItem("argument4"))
          : null,
      lotStatus: searchLotStatus,
      type: "TAOUSER".includes(atob(localStorage.getItem("argument6")))
        ? 1
        : "BUYER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEBUYER" == atob(localStorage.getItem("argument6"))
        ? 2
        : "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEAUCTIONEER" ==
            atob(localStorage.getItem("argument6"))
        ? 3
        : "",
      auctionDetailId: fromLiveAuction
        ? window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
          ? parseInt(
              atob(
                window.location.pathname &&
                  window.location.pathname.split("/") &&
                  window.location.pathname.split("/")[2]
              )
            )
          : null
        : null,
      isExport: 0,
    };
    dispatch(fetchAuctionSearchBidBookData(payloadDataForDefault));

    // let payload = {
    //   auctionCenterId: auctionCenterId,
    //   sessionDetailId: 647,
    // };
    // dispatch(fetchLotNumberBySessionDetailId(payload));
  }, []);

  let fetchAuctionSearchBidBookResponse = useSelector(
    (state) =>
      state.auctionSearchBidBookReducer.fetchAuctionSearchBidBook?.responseData
  );

  let fetchAuctionSearchBidBookExportResponse = useSelector(
    (state) =>
      state.auctionSearchBidBookReducer.fetchAuctionSearchBidBookExport
        ?.responseData
  );

  const fetchMarkDetailsByAuctionCenterIdResponse = useSelector(
    (state) => state.markReducer.fetchMarkDetailsByAuctionCenterId.responseData
  );

  const fetchGradeDetailsByAuctionCenterIdResponse = useSelector(
    (state) => state.gradeManage.fetchGradeDetailsByAuctionCenterId.responseData
  );

  const fetchSessionTimeForBidBookResponse = useSelector(
    (state) =>
      state.auctionSearchBidBookReducer.fetchSessionTimeForBidBookSuccess
        ?.responseData
  );

  const handleSearch = (type) => {
    generalType = type;
    let tempData =
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[4];
    let auctionCenterId = tempData && atob(tempData);
    let payloadData = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      gradeId: searchGradeId,
      markId: searchMarkId,
      bidderId:
        "BUYER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEBUYER" ==
          atob(localStorage.getItem("argument6")) ||
        "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEAUCTIONEER" ==
          atob(localStorage.getItem("argument6"))
          ? atob(localStorage.getItem("argument4"))
          : null,
      lotStatus: searchLotStatus,
      type: "TAOUSER".includes(atob(localStorage.getItem("argument6")))
        ? 1
        : "BUYER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEBUYER" == atob(localStorage.getItem("argument6"))
        ? 2
        : "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEAUCTIONEER" ==
            atob(localStorage.getItem("argument6"))
        ? 3
        : "",
      auctionDetailId: fromLiveAuction
        ? window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
          ? parseInt(
              atob(
                window.location.pathname &&
                  window.location.pathname.split("/") &&
                  window.location.pathname.split("/")[2]
              )
            )
          : null
        : null,
      sessionDetailId: sessionDetailId,
      sessionTime: sessionTime,
      lotNo: lotNumber,
      isExport: type,
    };
    setLoader(true);
    dispatch(fetchAuctionSearchBidBookData(payloadData));
  };

  const clearSearch = () => {
    setSearchMarkId("");
    setSearchGradeId("");
    setSearchLotStatus(4);
    setSessionTime("");
    setSessionDetailId("");
    setLotNumber("");
    generalType = 0;

    let tempData =
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[4];
    let auctionCenterId = tempData && atob(tempData);

    let payloadData = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      gradeId: searchGradeId,
      markId: searchMarkId,
      bidderId:
        "BUYER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEBUYER" ==
          atob(localStorage.getItem("argument6")) ||
        "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
        "POSTAUCTIONASSOCIATEAUCTIONEER" ==
          atob(localStorage.getItem("argument6"))
          ? atob(localStorage.getItem("argument4"))
          : null,
      lotStatus: searchLotStatus,
      type: "TAOUSER".includes(atob(localStorage.getItem("argument6")))
        ? 1
        : "BUYER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEBUYER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEBUYER" == atob(localStorage.getItem("argument6"))
        ? 2
        : "AUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "ASSOCIATEAUCTIONEER" == atob(localStorage.getItem("argument6")) ||
          "POSTAUCTIONASSOCIATEAUCTIONEER" ==
            atob(localStorage.getItem("argument6"))
        ? 3
        : "",
      auctionDetailId: fromLiveAuction
        ? window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
          ? parseInt(
              atob(
                window.location.pathname &&
                  window.location.pathname.split("/") &&
                  window.location.pathname.split("/")[2]
              )
            )
          : null
        : null,
      sessionDetailId: sessionDetailId,
      isExport: 0,
    };
    setLoader(true);
    dispatch(fetchAuctionSearchBidBookData(payloadData));
    dispatch(fetchLotNumberBySessionDetailIdSuccess([]));
  };

  let fetchAuctionSearchBidBookDataApiCallResponse = useSelector(
    (state) =>
      state.auctionSearchBidBookReducer.fetchAuctionSearchBidBookDataApiCall
  );

  useEffect(() => {
    if (fetchAuctionSearchBidBookDataApiCallResponse) {
      if (1 == generalType) {
        let exportFileData =
          fetchAuctionSearchBidBookExportResponse?.exported_file;
        if (exportFileData != null) {
          Base64ToExcelDownload(exportFileData, "BidBookData.xlsx");
        }
      } else if (2 == generalType) {
        let exportFileData =
          fetchAuctionSearchBidBookExportResponse?.exported_file;
        if (exportFileData != null) {
          uploadedFileDownload(
            exportFileData,
            "BidBookData.pdf",
            `data:application/pdf;base64`
          );
        }
      }
      dispatch(fetchAuctionSearchBidBookDataApiCall(false));
      setLoader(false);
    }
  });

  const sessionDetailIdAndSessionTime = (value, key) => {
    if (value != "") {
      setSessionDetailId(value);
      setSessionTime(key);
      dispatch(fetchLotNumberBySessionDetailIdSuccess([]));
      setLotNumber("");

      let tempData =
        window.location.pathname &&
        window.location.pathname.split("/") &&
        window.location.pathname.split("/")[4];

      let auctionCenterId = tempData && atob(tempData);

      let payload = {
        auctionCenterId: auctionCenterId,
        sessionDetailId: value,
      };
      dispatch(fetchLotNumberBySessionDetailId(payload));
    } else {
      setSessionDetailId("");
      setSessionTime("");
      dispatch(fetchLotNumberBySessionDetailIdSuccess([]));
    }
  };

  let fetchLotNumberBySessionDetailIdResponse = useSelector(
    (state) =>
      state.auctionSearchBidBookReducer?.fetchLotNumberBySessionDetailId
  );

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return fetchAuctionSearchBidBookResponse;
    const sorted = [...fetchAuctionSearchBidBookResponse].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [fetchAuctionSearchBidBookResponse, sortConfig]);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="row align-items-end">
            {!fromLiveAuction ? (
              <div className="col-md-4">
                <div className="FormGroup">
                  <label>Session Time</label>
                  <select
                    className="form-control select-form"
                    value={sessionDetailId}
                    onChange={(e) =>
                      sessionDetailIdAndSessionTime(
                        e.target.value,
                        e.target.key
                      )
                    }
                  >
                    <option key="" value="">
                      Select Session Time
                    </option>
                    {fetchSessionTimeForBidBookResponse?.map((state) => (
                      <option
                        key={state.SessionTime}
                        value={state.auctionSessionDetailId}
                      >
                        {state.SessionTime}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}

            {!"BUYER".includes(atob(sessionStorage.getItem("argument6"))) ? (
              <div className="col-md-4">
                <div className="FormGroup">
                  <label>Lot No</label>
                  <select
                    className="form-control select-form"
                    value={lotNumber}
                    onChange={(e) => setLotNumber(e.target.value)}
                    disabled={sessionDetailId == "" ? true : false}
                  >
                    <option value="">Select Lot No</option>
                    {fetchLotNumberBySessionDetailIdResponse &&
                      fetchLotNumberBySessionDetailIdResponse.map((state) => (
                        <option value={state.auctionItemDetailId}>
                          {state.lotNo}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}

            {!"AUCTIONEER".includes(
              atob(sessionStorage.getItem("argument6"))
            ) ? (
              <>
                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Mark</label>
                    <select
                      className="form-control select-form"
                      value={searchMarkId}
                      onChange={(e) => setSearchMarkId(e.target.value)}
                      disabled={fromLiveAuction ? true : false}
                    >
                      <option value="">All</option>
                      {fetchMarkDetailsByAuctionCenterIdResponse?.map(
                        (state) => (
                          <option key={state.markId} value={state.markId}>
                            {state.markName}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="FormGroup">
                    <label>Grade</label>
                    <select
                      className="form-control select-form"
                      value={searchGradeId}
                      onChange={(e) => setSearchGradeId(e.target.value)}
                      disabled={fromLiveAuction ? true : false}
                    >
                      <option value="">All</option>
                      {fetchGradeDetailsByAuctionCenterIdResponse?.map(
                        (state) => (
                          <option key={state.gradeId} value={state.gradeId}>
                            {state.gradeName}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            {"AUCTIONEER".includes(
              atob(sessionStorage.getItem("argument6"))
            ) ? (
              <div className="col-md-4">
                <div className="FormGroup">
                  <label>Lot Status</label>
                  <select
                    className="form-control select-form"
                    value={searchLotStatus}
                    onChange={(e) => setSearchLotStatus(e.target.value)}
                  >
                    {lotStatusData?.map((state) => (
                      <option key={state.lotKey} value={state.lotValue}>
                        {state.lotKey}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="col-md-12">
              <div className="BtnGroup">
                <button className="SubmitBtn" onClick={() => handleSearch(0)}>
                  Search
                </button>

                <button className="Clear" onClick={() => clearSearch()}>
                  Clear
                </button>

                <button class="SubmitBtn" onClick={() => handleSearch(1)}>
                  <i class="fa fa-file-excel"></i>
                </button>

                <button class="SubmitBtn" onClick={() => handleSearch(2)}>
                  <i class="fa fa-file-pdf"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader ? (
        <>
          <div className="">
            <ThreeDots
              visible={true}
              height="80"
              width="80"
              color="#4fa94d"
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      ) : (
        <div className="row mt-4">
          <div className="col-12">
            <div className="TableBox">
              <table className="table">
                <thead>
                  {"BUYER".includes(
                    atob(sessionStorage.getItem("argument6"))
                  ) ? (
                    <tr>
                      <th onClick={() => handleSort("lotNo")}>Lot No.</th>
                      <th onClick={() => handleSort("origin")}>Origin</th>
                      <th onClick={() => handleSort("mark")}>Mark</th>
                      <th onClick={() => handleSort("grade")}>Grade</th>
                      <th onClick={() => handleSort("noOfPackages")}>
                        Buy Qty. (No. of Packages)
                      </th>
                      <th onClick={() => handleSort("maxBidPrice")}>
                        Max Bid Price
                      </th>
                      <th onClick={() => handleSort("serverBidNo")}>
                        Server Bid No.
                      </th>
                      <th onClick={() => handleSort("exitStatus")}>
                        Bid Exit Status
                      </th>
                      <th onClick={() => handleSort("bidStatus")}>
                        Bid Status
                      </th>
                      <th onClick={() => handleSort("bidDateTime")}>
                        Knockdown Time
                      </th>
                    </tr>
                  ) : "AUCTIONEER".includes(
                      atob(sessionStorage.getItem("argument6"))
                    ) ? (
                    <tr>
                      <th onClick={() => handleSort("invoiceNumber")}>
                        Invoice No.
                      </th>
                      <th onClick={() => handleSort("lotNo")}>Lot No.</th>
                      <th onClick={() => handleSort("noOfPackages")}>
                        Buy Qty. (No. of Packages)
                      </th>
                      <th onClick={() => handleSort("maxBidPrice")}>
                        Max Bid Price
                      </th>
                      <th onClick={() => handleSort("bidDateTime")}>
                        Bid Date And Time
                      </th>
                      <th onClick={() => handleSort("exitStatus")}>
                        Bid Status
                      </th>
                      <th onClick={() => handleSort("lotStatus")}>
                        Lot Status
                      </th>
                    </tr>
                  ) : (
                    <tr>
                      <th onClick={() => handleSort("lotNo")}>Lot No.</th>
                      <th onClick={() => handleSort("invoiceNumber")}>
                        Invoice No.
                      </th>
                      <th onClick={() => handleSort("serverBidNo")}>
                        Server Bid No.
                      </th>
                      <th onClick={() => handleSort("noOfPackages")}>
                        Buy Qty. (No. of Packages)
                      </th>
                      <th onClick={() => handleSort("buyerName")}>
                        Buyer Name
                      </th>
                      <th onClick={() => handleSort("maxBidPrice")}>
                        Max Bid Price
                      </th>
                      <th onClick={() => handleSort("closingPrice")}>
                        Closing Price
                      </th>
                      <th onClick={() => handleSort("exitStatus")}>
                        Bid Exit Status
                      </th>
                      <th onClick={() => handleSort("bidStatus")}>
                        Bid Status
                      </th>
                      <th onClick={() => handleSort("bidDateTime")}>
                        Bid Date & Time
                      </th>
                    </tr>
                  )}
                </thead>

                {fetchAuctionSearchBidBookResponse != null &&
                fetchAuctionSearchBidBookResponse.length > 0 ? (
                  <tbody>
                    {sortedData &&
                      sortedData.map((data) => (
                        <>
                          {"BUYER".includes(
                            atob(sessionStorage.getItem("argument6"))
                          ) ? (
                            <tr>
                              <td>{data.lotNo}</td>
                              <td>{data.origin}</td>
                              <td>{data.mark}</td>
                              <td>{data.grade}</td>
                              <td>{data.noOfPackages}</td>
                              <td>{data.maxBidPrice}</td>
                              <td>{data.serverBidNo}</td>
                              <td>{data.exitStatus}</td>
                              <td>{data.bidStatus}</td>
                              <td>{data.bidDateTime}</td>
                            </tr>
                          ) : "AUCTIONEER".includes(
                              atob(sessionStorage.getItem("argument6"))
                            ) ? (
                            <tr>
                              <td>{data.invoiceNumber}</td>
                              <td>{data.lotNo}</td>
                              <td>{data.noOfPackages}</td>
                              <td>{data.maxBidPrice}</td>
                              <td>{data.bidDateTime}</td>
                              <td>{data.exitStatus}</td>
                              <td>{data.lotStatus}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td>{data.lotNo}</td>
                              <td>{data.invoiceNumber}</td>
                              <td>{data.serverBidNo}</td>
                              <td>{data.noOfPackages}</td>
                              <td>{data.buyerName}</td>
                              <td>{data.maxBidPrice}</td>
                              <td>{data.closingPrice}</td>
                              <td>{data.exitStatus}</td>
                              <td>{data.bidStatus}</td>
                              <td>{data.bidDateTime}</td>
                            </tr>
                          )}
                        </>
                      ))}
                  </tbody>
                ) : (
                  "No records found"
                )}
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default AuctionSearchBidBook;
